import {DropdownContainer} from "./Dropdown/DropdownContainer";

const components = Array.from(document.querySelectorAll('.js-wl-selector-container'));
components.forEach(component => new DropdownContainer(component as HTMLElement))
